var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRootsWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6479 2.77588L11.3674 13.4966C11.3674 13.4966 8.5528 14.5933 7.51509 15.6329C5.48022 17.6678 3.33252 23.1892 3.33252 23.1892L6.59781 19.7914L8.84441 21.9531L7.65708 18.6884L8.08561 18.2447C8.08561 18.2447 11.3357 15.4364 13.2184 15.728C15.5005 16.083 18.2137 20.5267 18.2137 20.5267L17.0599 25.6551C13.6305 27.3096 10.3024 29.1543 6.95597 30.9737L11.9823 29.5664L12.743 32.6028L13.6939 29.4142C13.6939 29.4142 16.1027 27.4998 17.548 27.4174C18.8666 27.3477 21.2501 28.8437 21.2501 28.8437L18.8793 31.4111L23.8682 29.3699L19.9189 26.5172C21.865 23.2019 22.4102 20.3936 21.7255 16.5838C22.613 15.8548 24.1534 15.0878 25.5227 15.728L24.369 17.6615L27.3293 21.4269L26.3531 18.0672L27.0061 16.7233C28.6669 18.2383 29.7192 20.6979 29.808 22.8596C29.903 25.0719 26.7398 28.7486 26.7398 28.7486C30.7588 26.2256 31.697 23.2906 31.0314 20.2922C31.7541 20.3683 32.5021 20.1718 33.3325 20.026C31.3737 19.335 30.8095 18.6567 30.0742 17.6615C29.5861 16.6726 28.9712 15.6963 28.2866 14.7328L28.407 13.6615L26.4799 12.2098L24.1027 12.7803L22.4862 2.77588H12.6479Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRootsWhite);
export default __webpack_public_path__ + "static/media/roots-white.56d217ef8d86ce32a218476851de5eea.svg";
export { ForwardRef as ReactComponent };